var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({
    margin: _vm.isWideScreen ? '10%' : '0%',
    'margin-top': _vm.isWideScreen ? '25px' : '0px',
  })},[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"clearfix",attrs:{"slot":"header"},slot:"header"},[(_vm.txtList.length > 0)?_c('span',{staticClass:"title"},[_vm._v("\n        "+_vm._s(_vm.txtList[0])+"\n      ")]):_vm._e()]),_vm._v(" "),_c('div',_vm._l((_vm.txtList),function(txt,index){return _c('span',{key:index},[(index > 0 && _vm.issubTitle(txt))?_c('h3',{staticClass:"subtitle"},[_vm._v("\n          "+_vm._s(txt)+"\n        ")]):(index > 0 && _vm.isValidsubTitle(txt))?_c('p',[_vm._v(_vm._s(txt))]):_vm._e()])}),0)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2295796b","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/userprotocol.vue
// module id = 201
// module chunks = 0